<ng-container>
    <span [innerHTML]="text" [ngStyle]="{'color': textColor}"></span>
    <a *ngIf="!showOnlyText" [ngStyle]="{'color': linkColor,'cursor': 'pointer'}" (click)="toggleLength()">
      <span *ngIf="!hide">...Read more</span>
      <span *ngIf="hide">...Read less</span>
    </a>
  </ng-container>